export default "__VITE_ASSET__d289559f__"